<template>
  <div class="position-relative" style="width: 60px">
    <el-image style="width: 56px; height: 56px; border-radius: 2px" fit="cover"
              :src="source?source:'https://chat.zalo.me/assets/icon-file-empty.6796cfae2f36f6d44242f7af6104f2bb.svg'" />
    <el-tooltip class="item" effect="dark" :content="name" placement="bottom-start">
      <div style="" class="w-100 font-size-11 fw-semibold text-break rounded-1  text-center w-100 text-2-line-new ">
        {{ name }}
      </div>
    </el-tooltip>
  </div>
</template>

<script>
import Config from "../../lib/Config";

export default {
  name: "File",
  props: {
    id: {
      type: String
    }
  },
  data() {
    return {
      name: "",
      contentType: "",
      source: ""
    };
  },
  methods: {
    getUrlImage(image) {
      let HOST = "";
      if (Config.DEV) {
        HOST = Config.HOST;
      } else {
        HOST = "https://zalo.salework.net";
      }
      return HOST + "/api/image/" + image;
    },
    getNameFile() {
      return this.$http.get("/api/image/" + this.id).then(resp => {
        if (!resp.data) {
          this.source = this.getUrlImage(this.id);
          return;
        }
        let data = resp.data;
        this.name = data.fileName;
        this.contentType = data.contentType;
        let type = this.app.iconType.map(s => s.type);
        type.forEach(s => {
          if (this.contentType.includes(s)) {
            let icon = this.app.iconType.find(t => t.type === s);
            if (icon) {
              this.source = icon.url;
            }
          } else if (this.contentType.includes("sheet")) {
            this.source = this.app.iconType.find(s => s.type === "xlsx").url;
          }
        });
      });

    }
  },
  created() {
    this.getNameFile();
  }
};
</script>

<style scoped>

</style>